import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {MedicineStickersListComponent} from "./components/medicine-stickers-list/medicine-stickers-list.component";
import {MedicineStickersViewComponent} from "./view-components/medicines-stickers-view/medicines-stickers-view.component";
import {CreateStickerSheetViewComponent} from "./view-components/create-sticker-sheet-view/create-sticker-sheet-view.component";
import {StickerSheetsViewComponent} from "./view-components/sticker-sheets-view/sticker-sheets-view.component";
import {StickerSheetsListComponent} from "./components/sticker-sheets-list/sticker-sheets-list.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {VisbosCoreModule} from "../core/visbos-core/visbos-core.module";
import {DragulaModule} from "ng2-dragula";
import {MedicineStickersNavigationComponent} from "./components/medicine-stickers-navigation/medicine-stickers-navigation.component";
import {CustomStickerPageLayoutComponent} from "./components/custom-sticker-page-layout/custom-sticker-page-layout.component";
import {StickerPageComponent} from "./components/custom-sticker-page-layout/sticker-page/sticker-page.component";
import {StickersAuthorizedGuard} from "./guards/stickers-authorized.guard";
import {StoreManagementModule} from "../store-management/store-management.module";
import {MedicinesViewComponent} from "./view-components/medicines-view/medicines-view.component";
import {MedicineStickersService} from "./services/medicine-stickers.service";
import {StickyModule} from "ng2-sticky-kit";
import { StickerFormatFormComponent } from './components/sticker-format-form/sticker-format-form.component';
import {OrganizationModule} from "../organization/organization.module";
import { StickerFormatsViewComponent } from './view-components/sticker-formats-view/sticker-formats-view.component';
import { StickerFormatsTableComponent } from './components/sticker-formats-table/sticker-formats-table.component';

@NgModule({
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule, RouterModule,
    VisbosCoreModule, StoreManagementModule, OrganizationModule,
    DragulaModule, StickyModule
  ],
  providers: [StickersAuthorizedGuard, MedicineStickersService],
  declarations: [MedicineStickersNavigationComponent,
    MedicineStickersListComponent, MedicineStickersViewComponent, CreateStickerSheetViewComponent, StickerSheetsListComponent, StickerSheetsViewComponent, CustomStickerPageLayoutComponent, StickerPageComponent, MedicinesViewComponent, StickerFormatFormComponent, StickerFormatsViewComponent, StickerFormatsTableComponent]
})
export class MedicineStickersModule {
}



// WEBPACK FOOTER //
// ./src/app/medicine-stickers/medicine-stickers.module.ts